import styled from "styled-components";

export const StepperWrapper = styled.div`
  width: 100%;
  max-width: 65%;
  margin: auto;
  margin-bottom: ${({ theme }) => theme.tokens.sizes.spacings.giga};
`;
